import { render } from "./PushNotificationMaster.vue?vue&type=template&id=4f4a0a63&scoped=true"
import script from "./PushNotificationMaster.vue?vue&type=script&lang=js"
export * from "./PushNotificationMaster.vue?vue&type=script&lang=js"

import "./PushNotificationMaster.vue?vue&type=style&index=0&id=4f4a0a63&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4a0a63"]])

export default __exports__